exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ListNavigation-root-Ho7vN {\n  margin: 0;\n}\n\n.ListNavigation-exitText-6mCc0 {\n  color: var(--btn-secondary-bg) !important;\n}\n\n.ListNavigation-headerPosition-tLN1N {\n  width: 100%;\n  position: absolute;\n  top: 12px;\n  left: 0;\n  right: 0;\n  line-height: normal;\n}\n\n@supports (-webkit-touch-callout: none) {\n  .ListNavigation-headerPosition-tLN1N {\n    top: 10px;\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  @supports (-webkit-touch-callout: none) {\n    .ListNavigation-headerPosition-tLN1N {\n      top: 13px;\n      padding: 0 12px;\n    }\n  }\n}\n\n\n@media screen and (max-width: 767px) {\n  .ListNavigation-hideSm-nrw8p {\n    display: none !important;\n  }\n\n}", ""]);

// exports
exports.locals = {
	"root": "ListNavigation-root-Ho7vN",
	"exitText": "ListNavigation-exitText-6mCc0",
	"headerPosition": "ListNavigation-headerPosition-tLN1N",
	"hideSm": "ListNavigation-hideSm-nrw8p"
};